import { RouteObject } from 'react-router-dom'
import pointsRoutes from './points/routes'
import rewardsRoutes from './rewards/routes'

const routes: RouteObject[] = [...pointsRoutes, ...rewardsRoutes]

export default routes
